import { render, staticRenderFns } from "./PayQuery.vue?vue&type=template&id=356635a6&scoped=true"
import script from "./PayQuery.vue?vue&type=script&lang=js"
export * from "./PayQuery.vue?vue&type=script&lang=js"
import style0 from "./PayQuery.vue?vue&type=style&index=0&id=356635a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356635a6",
  null
  
)

export default component.exports